import React, {useContext} from 'react';
import {Link} from "react-router-dom";
import styles from './privacyList.module.scss';

function PrivacyListRU() {

  return (
    <>
      <p style={{ marginBottom: '0pt', textAlign: 'justify', lineHeight: '15pt' }}>
        <span
          style={{
            fontFamily: 'Times New Roman',
            fontSize: '10.5pt',
            color: '#808080',
          }}
        >
          &nbsp;
        </span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
				  Настоящая Политика конфиденциальности объясняет, кто мы такие, как мы обрабатываем (т.е. собираем, ведем записи, организуем, структурируем, храним, адаптируем или изменяем, извлекаем, используем, раскрываем путем передачи, распространяем или иным образом делаем доступной, согласовываем или комбинируем, ограничиваем использование, стираем или уничтожаем) личную информацию о Вас и как Вы можете реализовать свои права на конфиденциальность. Мы - BATTLE OF PREDICTIONS TECHNOLOGY INC, компания, действующая в соответствии с законодательством Соединенных Штатов Америки, зарегистрированная по адресу: 2546 e 17th street, 2nd floor, BROOKLYN, NY 11235 (далее - "BATTLE OF PREDICTIONS" или "мы"), разработчик и издатель игр и мобильных игровых приложений, доступных через магазины приложений, включая Apple App Store и Google Play Store. Настоящая Политика конфиденциальности распространяется на личную информацию, которую мы собираем с помощью нашего веб-сайта, игр, мобильных приложений и других продуктов (далее - "Игры", а вместе именуемые "Услуги"). Пользуясь нашими Услугами, Вы соглашаетесь с настоящей Политикой конфиденциальности и даете согласие на обработку нами информации, указанной в ней. Если Вы не согласны с настоящей Политикой конфиденциальности, пожалуйста, не пользуйтесь нашими Услугами.
        </span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>1. ИНФОРМАЦИЯ, КОТОРУЮ МЫ СОБИРАЕМ ОТ ВАС</span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
				Большая часть информации, которую мы собираем о Вас, поступает непосредственно от Вас, когда Вы посещаете наш сайт, играете в наши Игры или взаимодействуете с рекламой третьих лиц в наших Играх или с нашей рекламой в играх других издателей. В целом, информация, которую мы собираем о Вас, относится к типу используемого Вами устройства, информации, которая помогает нам идентифицировать Ваше устройство, тому, как Вы играете в наши Игры, и может включать информацию, которую Вы предоставляете нам, когда добровольно связываетесь с нами. Мы также можем собирать информацию от платформ и партнеров магазинов приложений и других третьих лиц, например, информацию о Ваших интересах и покупках в приложениях (при условии, что мы никогда не получаем информацию о Ваших платежах или кредитных картах).
        </span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
				Информация, которую мы можем собирать о Вас с помощью Услуг, в целом относится к следующим категориям:

        </span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>(a) Информация, которую Вы предоставляете добровольно.</span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
				В некоторых разделах наших Услуг мы можем попросить Вас предоставить личную информацию на добровольной основе. Например, мы будем запрашивать определенную информацию для того, чтобы Вы (i) зарегистрировались в наших Услугах/Играх, например:
        </span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
				в случае регистрации через аккаунт Google: sub (уникальный идентификатор пользователя), фамилия, имя, фотография пользователя;
        </span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
				в случае регистрации через учетную запись Apple (только для устройств IOS) - apple id, имя, фамилия;
        </span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
				в случае регистрации через аккаунт социальной сети (типа Facebook) - уникальный идентификатор пользователя, имя, фамилия, фотография пользователя.

        </span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>&nbsp;</span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>(ii) для направления нам запросов:</span>
      </p>
      <ul style={{ margin: '0pt', paddingLeft: '0pt' }}>
        <li
          style={{
            marginTop: '14pt',
            marginLeft: '27.6pt',
            marginBottom: '12pt',
              lineHeight: 'normal',
            paddingLeft: '8.4pt',
            fontFamily: 'serif',
            fontSize: '10pt',
          }}
        >
          <span style={{ fontFamily: 'Times New Roman', fontSize: '12pt' }}>
          Ваше имя, адрес электронной почты или другие данные, необходимые для обработки Ваших запросов;
          </span>
        </li>
        <li
          style={{
            marginLeft: '27.6pt',
            marginBottom: '12pt',
              lineHeight: 'normal',
            paddingLeft: '8.4pt',
            fontFamily: 'serif',
            fontSize: '10pt',
          }}
        >
          <span style={{ fontFamily: 'Times New Roman', fontSize: '12pt' }}>
            любая информация, которую Вы предоставляете нашей службе поддержки по электронной почте.
          </span>
        </li>
      </ul>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
  				Личную информацию, которую Вас просят предоставить, и причины, по которым Вас просят ее предоставить, мы постараемся объяснить Вам в тот момент, когда попросим Вас предоставить данную информацию.
      </span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>(b) Информация, которую мы собираем автоматически.</span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
				Когда Вы пользуетесь нашими Услугами, мы также можем автоматически собирать от Вас и/или с Вашего устройства определенную информацию, которая может считаться персональными данными в соответствии с действующим законодательством о защите данных, например:
        </span>
      </p>
      <ul style={{ margin: '0pt', paddingLeft: '0pt' }}>
        <li
          style={{
            marginTop: '14pt',
            marginLeft: '27.6pt',
            marginBottom: '12pt',
              lineHeight: 'normal',
            paddingLeft: '8.4pt',
            fontFamily: 'serif',
            fontSize: '10pt',
          }}
        >
          <span style={{ fontFamily: 'Times New Roman', fontSize: '12pt' }}>
            Данные и аналитика об использовании Вами наших Услуг (например, прогресс в игре, пройденные игры, продолжительность сеанса, предпочитаемые настройки, просмотренная реклама в игре, переходы по внутриигровым ссылкам или просто предпочтения в игре, способы, с помощью которых Вы были направлены к нашим Услугам).
          </span>
        </li>
        <li
          style={{
            marginLeft: '27.6pt',
            marginBottom: '12pt',
              lineHeight: 'normal',
            paddingLeft: '8.4pt',
            fontFamily: 'serif',
            fontSize: '10pt',
          }}
        >
          <span style={{ fontFamily: 'Times New Roman', fontSize: '12pt' }}>
            Ваш IP-адрес и идентификаторы устройств, такие как рекламный ID, номера Device ID (подробнее см. ниже пояснения к рекламным ID и Device ID).
          </span>
        </li>
        <li
          style={{
            marginLeft: '27.6pt',
            marginBottom: '12pt',
              lineHeight: 'normal',
            paddingLeft: '8.4pt',
            fontFamily: 'serif',
            fontSize: '10pt',
          }}
        >
          <span style={{ fontFamily: 'Times New Roman', fontSize: '12pt' }}>
            Тип вашего устройства и используемая операционная система.
          </span>
        </li>
        <li
          style={{
            marginLeft: '27.6pt',
            marginBottom: '12pt',
              lineHeight: 'normal',
            paddingLeft: '8.4pt',
            fontFamily: 'serif',
            fontSize: '10pt',
          }}
        >
          <span style={{ fontFamily: 'Times New Roman', fontSize: '12pt' }}>
            Ваши сообщения внутри Услуг (например, внутриигровые сообщения, которыми Вы обмениваетесь с другими игроками).
          </span>
        </li>
        <li
          style={{
            marginLeft: '27.6pt',
            marginBottom: '12pt',
              lineHeight: 'normal',
            paddingLeft: '8.4pt',
            fontFamily: 'serif',
            fontSize: '10pt',
          }}
        >
          <span style={{ fontFamily: 'Times New Roman', fontSize: '12pt' }}>
            Широкое географическое местоположение (например, на уровне страны или города) на основе Вашего IP-адреса.
          </span>
        </li>
      </ul>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <em>
          <span style={{ fontFamily: 'Times New Roman' }}>Под рекламным идентификатором</span>
        </em>
        <span style={{ fontFamily: 'Times New Roman' }}>
          {' '}
          понимается Apple Identifier for Advertisers ("IDFA") в Apple и Google Advertising Identity ("GAID"). Это уникальные идентификаторы мобильного устройства, которые рекламодатели используют для персонализированной рекламы. Они едины для всех мобильных приложений и, таким образом, позволяют осуществлять отслеживание рекламы одновременно во многих приложениях. В Apple от них можно отказаться, выбрав опцию "Ограничить отслеживание рекламы" в настройках конфиденциальности. В Google Android от этой рекламы можно отказаться, выбрав опцию "Opt-out of personalized ads/ отказаться от персонализированной рекламы". Рекламные идентификаторы - это непостоянные, неперсональные идентификаторы, которые уникальным образом связаны с Вашим устройством.
        </span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <em>
          <span style={{ fontFamily: 'Times New Roman' }}>Идентификатор / информация об устройстве</span>
        </em>
        <span style={{ fontFamily: 'Times New Roman' }}>
          {' '}
          это тип устройства, модель устройства, производитель устройства, операционная система устройства и его язык или другие технические данные, такие как размер экрана или процессора, или комбинация этих данных, доступных разработчику для проверки совместимости устройства с конкретным приложением.
        </span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>(c)</span>
        <span style={{ fontFamily: 'Times New Roman' }}>&nbsp;</span>
        <span style={{ fontFamily: 'Times New Roman' }}>Информация, которую мы получаем из сторонних источников.</span>
      </p>
      <ul style={{ margin: '0pt', paddingLeft: '0pt' }}>
        <li
          style={{
            marginTop: '14pt',
            marginLeft: '27.6pt',
            marginBottom: '12pt',
              lineHeight: 'normal',
            paddingLeft: '8.4pt',
            fontFamily: 'serif',
            fontSize: '10pt',
          }}
        >
          <span style={{ fontFamily: 'Times New Roman', fontSize: '12pt' }}>Сторонняя социальная сеть (сети).</span>
          <span style={{ fontFamily: 'Times New Roman', fontSize: '12pt' }}>&nbsp;</span>
          <span style={{ fontFamily: 'Times New Roman', fontSize: '12pt' }}>
               Игровой сервис Google Play, Apple Game Center, другие социальные сети типа Facebook ("Сторонние социальные сети"). Вы можете подключиться к нашим Услугам через свою учетную запись в социальной сети. То, какую именно информацию мы получаем из Вашей социальной сети, зависит от настроек конфиденциальности Вашей социальной сети, но, как правило, она включает основные сведения о Вашем профиле, такие как имя пользователя, пол, Ваши друзья, играющие в ту же игру (см. также ниже "Социальные сети третьих лиц").
          </span>
        </li>
        <li
          style={{
            marginLeft: '27.6pt',
            marginBottom: '12pt',
              lineHeight: 'normal',
            paddingLeft: '8.4pt',
            fontFamily: 'serif',
            fontSize: '10pt',
          }}
        >
          <span style={{ fontFamily: 'Times New Roman', fontSize: '12pt' }}>
            Сторонние поставщики услуг. Мы можем получать персональную информацию о Вас из сторонних источников. Мы можем получить Вашу личную информацию, например, когда Вы установили нашу игру, а перед установкой нажали на рекламу этой же игры.
          </span>
        </li>
        <li
          style={{
            marginLeft: '27.6pt',
            marginBottom: '12pt',
              lineHeight: 'normal',
            paddingLeft: '8.4pt',
            fontFamily: 'serif',
            fontSize: '10pt',
          }}
        >
          <span style={{ fontFamily: 'Times New Roman', fontSize: '12pt' }}>
            Рекламные партнеры. Время от времени мы также можем получать персональную информацию о Вас из других сторонних источников. Например, если Вы нажали на рекламу, направляющую Вас на одну из наших Услуг (например, на рекламу одной из наших Игр в игре другого издателя), нам будет предоставлена информация о том, из какой рекламной сети и рекламной кампании произошла установка (см. ниже также "Реклама").
          </span>
        </li>
      </ul>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
          Список наших текущих поставщиков услуг и партнеров доступен
        </span>
        <strong>
          <u>
            <Link className={styles.link} to="/providers" style={{ fontFamily: 'Times New Roman' }}>здесь</Link>.
          </u>
        </strong>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>(d) Отсутствие специальных категорий информации.</span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
				Мы не запрашиваем и не собираемся собирать какие-либо "специальные категории информации", такие как персональные данные, раскрывающие расовую или этническую принадлежность, политические взгляды, религиозные или философские убеждения, членство в профсоюзе, генетические данные, биометрические данные для целей однозначной идентификации физического лица, данные о здоровье или данные о сексуальной жизни или сексуальной ориентации физического лица. Пожалуйста, будьте осторожны, по своему желанию предоставляя эту информацию о себе (или других лицах) в наших Услугах.

        </span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>2. КАК МЫ ИСПОЛЬЗУЕМ ВАШУ ИНФОРМАЦИЮ</span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>2.1. Общее</span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
          Мы используем собранную информацию о Вас/Вашем устройстве для предоставления Вам Услуг и наших Игр, а также для ведения бизнеса. Мы также используем ее для улучшения наших Услуг и Игр, повышения безопасности, а также в аналитических и исследовательских целях, чтобы убедиться, что мы предоставляем Вам наилучший опыт. Кроме того, мы используем Вашу информацию для продвижения наших Услуг и Игр в наших Играх, а также в приложениях других издателей и для показа Вам рекламы третьих лиц. Мы также используем Вашу информацию для отслеживания и предотвращения мошенничества при проведении рекламных кампаний, для выполнения наших юридических обязательств и в наших законных интересах.
        </span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>В частности, мы используем Вашу информацию для следующих целей:</span>
      </p>
      <ol style={{ margin: '0pt', paddingLeft: '0pt' }}>
        <li
          style={{
            marginTop: '14pt',
            marginLeft: '54.5pt',
            marginBottom: '12pt',
              lineHeight: 'normal',
            paddingLeft: '4pt',
            fontFamily: 'Times New Roman',
            fontSize: '12pt',
          }}
        >
          Предоставление и улучшение наших Услуг. Мы используем Вашу информацию для разработки, предоставления и улучшения наших Игр и других продуктов, Услуг и контента, адаптации наших продуктов и Услуг, предоставления обновлений Игр, устранения технических неполадок, понимания и анализа тенденций, связанных с использованием Игр, и управления Играми.

        </li>
        <li
          style={{
            marginLeft: '54.5pt',
            marginBottom: '12pt',
              lineHeight: 'normal',
            paddingLeft: '4pt',
            fontFamily: 'Times New Roman',
            fontSize: '12pt',
          }}
        >
          Показ рекламы. Мы используем Ваши данные для показа рекламы наших Игр в приложениях других издателей, а также для показа рекламы третьих лиц в наших Играх. Подробнее см. в разделе "Реклама" данной Политики конфиденциальности.

        </li>
        <li
          style={{
            marginLeft: '54.5pt',
            marginBottom: '12pt',
              lineHeight: 'normal',
            paddingLeft: '4pt',
            fontFamily: 'Times New Roman',
            fontSize: '12pt',
          }}
        >
          Отслеживание и предотвращение мошенничества при проведении рекламных кампаний. Мы используем Вашу информацию для отслеживания эффективности наших рекламных кампаний, а также для выявления и предотвращения мошенничества при проведении рекламных кампаний.
        </li>
        <li
          style={{
            marginLeft: '54.5pt',
            marginBottom: '12pt',
              lineHeight: 'normal',
            paddingLeft: '4pt',
            fontFamily: 'Times New Roman',
            fontSize: '12pt',
          }}
        >
          Аналитика и исследования. Мы используем Вашу информацию для понимания и анализа тенденций, связанных с использованием Игр, сбора демографической информации о нашей пользовательской базе, данных о том, откуда была загружена Игра. Мы также можем создавать отчеты и аналитические материалы для целей исследования или бизнес-анализа, например, для отслеживания потенциальных проблем или тенденций в наших Играх и Услугах или для тестирования наших новых игровых функций и контента.

        </li>
        <li
          style={{
            marginLeft: '54.5pt',
            marginBottom: '12pt',
              lineHeight: 'normal',
            paddingLeft: '4pt',
            fontFamily: 'Times New Roman',
            fontSize: '12pt',
          }}
        >
          Безопасность. Мы используем Вашу информацию для повышения безопасности и надежности наших Игр, продуктов и Услуг.
        </li>
        <li
          style={{
            marginLeft: '54.5pt',
            marginBottom: '12pt',
              lineHeight: 'normal',
            paddingLeft: '4pt',
            fontFamily: 'Times New Roman',
            fontSize: '12pt',
          }}
        >
          Поддержка клиентов. Мы используем Вашу информацию для оказания Вам поддержки и ответа на Ваши запросы.

        </li>
        <li
          style={{
            marginLeft: '54.5pt',
            marginBottom: '12pt',
              lineHeight: 'normal',
            paddingLeft: '4pt',
            fontFamily: 'Times New Roman',
            fontSize: '12pt',
          }}
        >
          Наши юридические обязательства. Мы используем Вашу информацию, когда это требуется по закону, например, мы используем данные о Вашей стране или регионе для целей налоговой отчетности.

        </li>
      </ol>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>2.2. Внутриигровые покупки.</span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
				Наши игры позволяют совершать покупки в приложениях. Мы не обрабатываем платежи за покупки в приложениях и не имеем доступа к информации о Вашей кредитной карте.

        </span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
				Операции оплаты покупок в приложениях осуществляются через магазин приложений с помощью Вашей учетной записи в App Store или Google Play (через поставщиков платежных услуг). От Вас требуется предоставить свои платежные реквизиты и личную информацию непосредственно таким поставщикам платежных услуг. Мы не участвуем в сборе и обработке такой информации: вместо этого мы лишь получаем от соответствующего поставщика платежных услуг уведомление об успешном завершении платежа.

        </span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
				Любые процессы после покупки контролируются магазинами Apple и Google и регулируются специальными условиями таких магазинов. Пожалуйста, ознакомьтесь с политикой конфиденциальности и условиями обслуживания используемого Вами магазина приложений.

        </span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>3. КАК МЫ ДЕЛИМСЯ ВАШЕЙ ИНФОРМАЦИЕЙ</span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
				Мы не можем самостоятельно предоставлять все Услуги, необходимые для успешного функционирования Игр. Поэтому мы вынуждены передавать собранную информацию третьим лицам в целях разработки и предоставления наших Услуг, показа рекламы, проведения анализа и исследований, а также для оценки эффективности рекламных кампаний, проводимых нами и нашими Партнерами. Мы также оставляем за собой право раскрывать Вашу информацию (включая информацию, идентифицирующую личность), когда это требуется по закону, в частности раскрывать Вашу информацию в анонимной и агрегированной форме, то есть Вы не можете быть идентифицированы по ней.

        </span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>Мы можем передавать такую информацию следующим лицам:</span>
      </p>
      <ul style={{ margin: '0pt', paddingLeft: '0pt' }}>
        <li
          style={{
            marginTop: '14pt',
            marginLeft: '27.6pt',
            marginBottom: '12pt',
              lineHeight: 'normal',
            paddingLeft: '8.4pt',
            fontFamily: 'serif',
            fontSize: '10pt',
          }}
        >
          <span style={{ fontFamily: 'Times New Roman', fontSize: '12pt' }}>
            Наши поставщики аналитических услуг. Для предоставления услуг, проведения анализа и исследований мы используем сторонние аналитические системы, такие как Firebase. Данные об устройствах, которые мы передаем таким поставщикам, закодированы. Поставщики могут присвоить этим данным случайный идентификатор, и они не смогут соотнести их с Вами. Мы можем агрегировать эти данные для проведения сравнительного анализа.
          </span>
        </li>
        <li
          style={{
            marginLeft: '27.6pt',
            marginBottom: '12pt',
              lineHeight: 'normal',
            paddingLeft: '8.4pt',
            fontFamily: 'serif',
            fontSize: '10pt',
          }}
        >
          <span style={{ fontFamily: 'Times New Roman', fontSize: '12pt' }}>
            Наши поставщики облачных услуг. Мы храним полученную от Вас информацию на серверах, предоставляемых сторонними поставщиками облачных услуг, такими как Google Cloud Platform.
          </span>
        </li>
        <li
          style={{
            marginLeft: '27.6pt',
            marginBottom: '12pt',
              lineHeight: 'normal',
            paddingLeft: '8.4pt',
            fontFamily: 'serif',
            fontSize: '10pt',
          }}
        >
          <span style={{ fontFamily: 'Times New Roman', fontSize: '12pt' }}>
            Наши поставщики услуг по отслеживанию и предотвращению мошенничества. Для некоторых наших Игр мы используем поставщиков услуг по отслеживанию и предотвращению мошенничества в целях измерения эффективности и оптимизации наших рекламных кампаний, показа рекламы, проведения анализа для улучшения наших Услуг. Такие поставщики могут использовать API и SDK в наших Играх для сбора и анализа данных и информации о пользователях и устройствах, таких как впечатления, клики, установки и другие показатели эффективности рекламных кампаний, а также события после установки в приложении.
          </span>
        </li>
        <li
          style={{
            marginLeft: '27.6pt',
            marginBottom: '12pt',
              lineHeight: 'normal',
            paddingLeft: '8.4pt',
            fontFamily: 'serif',
            fontSize: '10pt',
          }}
        >
          <span style={{ fontFamily: 'Times New Roman', fontSize: '12pt' }}>
            Сторонние рекламные партнеры. Мы заключили договоры с некоторыми сторонними рекламными сетями, которые помогают нам доставлять Вам рекламу, что позволяет нам продолжать предлагать Игры бесплатно или по низкой цене.
          </span>
          <span style={{ fontFamily: 'Times New Roman', fontSize: '12pt' }}>&nbsp;</span>
        </li>
        <li
          style={{
            marginLeft: '27.6pt',
            marginBottom: '12pt',
              lineHeight: 'normal',
            paddingLeft: '8.4pt',
            fontFamily: 'serif',
            fontSize: '10pt',
          }}
        >
          <span style={{ fontFamily: 'Times New Roman', fontSize: '12pt' }}>
            Сторонний провайдер отслеживания рекламного партнера. Мы разрешаем нашим рекламным партнерам отслеживать показы, щелчки, установки и другие показатели эффективности рекламных кампаний через их провайдеров отслеживания для целей оценки эффективности их рекламных кампаний. Они могут использовать своих собственных сторонних провайдеров отслеживания.
          </span>
        </li>
        <li
          style={{
            marginLeft: '27.6pt',
            marginBottom: '12pt',
              lineHeight: 'normal',
            paddingLeft: '8.4pt',
            fontFamily: 'serif',
            fontSize: '10pt',
          }}
        >
          <span style={{ fontFamily: 'Times New Roman', fontSize: '12pt' }}>
            Другие сторонние поставщики услуг. Для разработки наших Игр мы используем различное программное обеспечение. Для разработки некоторых Игр мы сотрудничаем со сторонними студиями-разработчиками.
          </span>
        </li>
      </ul>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
				В будущем мы можем заключить договор с дополнительными Партнерами или изменить существующих Партнеров для выполнения каких-либо Услуг в связи с Играми. Эти изменения будут обновляться время от времени или незамедлительно в случае существенных изменений в нашей практике обработки данных.
        </span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
          Список наших текущих поставщиков услуг и партнеров, а также более подробная информация об их обработке персональных данных доступны

        </span>
        <strong>
          <u>
            <Link className={styles.link} to="/providers" style={{ fontFamily: 'Times New Roman' }}>
              здесь
            </Link>
            .
          </u>
        </strong>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
				Мы оставляем за собой право раскрывать Вашу информацию (включая персональные данные) в соответствии с законом, судебным процессом, судебным разбирательством и/или запросами государственных и правительственных органов в стране проживания или за ее пределами. Мы также можем раскрыть информацию о Вас, если сочтем, что в целях обеспечения национальной безопасности, охраны правопорядка или по другим общественно важным вопросам такое раскрытие необходимо или целесообразно. Мы также можем раскрыть информацию о Вас, если определим, что раскрытие информации является обоснованно необходимым для обеспечения соблюдения наших положений и условий или для защиты нашей деятельности, пользователей или пользовательского опыта. Кроме того, в случае реорганизации, слияния или продажи мы можем передать всю собранную нами информацию (включая персональные данные) соответствующей третьей стороне.

        </span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
				Дополнительные вопросы о сборе информации третьими лицами можно задать по электронному адресу&nbsp;
          <a className={styles.link} href="mailto:support@bofp.co">
            support@bofp.co
          </a>
        </span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>4. РЕКЛАМА</span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>4.1. Общее</span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
          Мы используем рекламу для финансирования наших Услуг и для того, чтобы наши Игры были доступны бесплатно. Мы предлагаем наши Игры бесплатно или по низкой цене, и для этого нам необходимо передавать собранную от Вас информацию нашим сторонним рекламным партнерам. В целях защиты Вашей конфиденциальности мы храним личную информацию только временно. Собранная информация помогает нам улучшать наш сайт и Игры и в то же время сохранять Игры бесплатными для широкого круга игроков.
        </span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
				Когда Вы используете наши Игры, мы руководствуемся своим законным интересом, чтобы показывать Вам рекламу. Правовым основанием для показа рекламы является законный интерес в соответствии с европейскими требованиями по защите данных согласно ст. 6 para. 1, лит. f GDPR.

        </span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
				Прежде чем передать какую-либо информацию нашим рекламным партнерам для целей
        </span>
        <em>
          <span style={{ fontFamily: 'Times New Roman' }}>персонализированной рекламы,</span>
        </em>
        <span style={{ fontFamily: 'Times New Roman' }}>мы всегда спрашиваем Вашего </span>
        <em>
          <span style={{ fontFamily: 'Times New Roman' }}>согласия.</span>
        </em>
        <span style={{ fontFamily: 'Times New Roman' }}>
          Это делается для того, чтобы улучшить наши Игры и предоставить игроку более релевантную рекламу. Мы разрешаем нашим рекламным партнерам показывать Вам персонализированные объявления только в том случае, если Вы нажали кнопку ACCEPT/ ПРИНЯТЬ в соответствующем всплывающем окне и тем самым дали согласие на передачу Вашей личной информации для целей персонализированной рекламы. Наши рекламные партнеры используют для целей персонализированной рекламы различные технологии, которые по-разному обрабатывают Вашу персональную информацию, поэтому, прежде чем нажать кнопку ACCEPT/ ПРИНЯТЬ для показа Вам персонализированной рекламы, ознакомьтесь с их практикой обработки данных.
        </span>
        <span style={{ fontFamily: 'Times New Roman' }}>&nbsp;</span>
        <span style={{ fontFamily: 'Times New Roman' }}>&nbsp;</span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
				Правовым основанием для показа персонализированных объявлений является согласие в соответствии с европейскими требованиями по защите данных согласно ст. 6 para. 1, лит. a GDPR. Кроме того, с внешними сетями поставщиков рекламных услуг были заключены соглашения об обработке данных в соответствии с требованиями ст. 28 GDPR. Мы также гарантируем, что наши внешние поставщики услуг придерживаются высокого уровня защиты данных.

        </span>
        <span style={{ fontFamily: 'Times New Roman' }}>&nbsp;</span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
          У Вас всегда есть возможность отозвать свое согласие на передачу Вашей личной информации для целей персонализированной рекламы. В системе Apple Вы можете отказаться от этого, выбрав опцию "Ограничить отслеживание рекламы" в настройках конфиденциальности. На Google Android отказаться от такой рекламы можно, выбрав опцию "Opt-out of personalized ads/ Отказаться от персонализирован6ной рекламы". Если Вы решите отозвать свое согласие или не предоставите его, Вы можете по-прежнему видеть то же количество рекламных объявлений на своем мобильном устройстве; однако эти объявления могут быть менее релевантными, поскольку они не будут основаны на понравившихся Вам темах, Ваших интересах, поведении, демографических данных и т.д. Наши рекламные партнеры могут продолжать показывать Вам рекламу, основанную на содержании используемого Вами приложения.
        </span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
          4.2. Внутриигровая реклама (т.е. когда Вы просматриваете рекламу в Наших играх).
        </span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
				Чтобы обеспечить показ рекламы в Играх, мы можем отправлять Ваш рекламный идентификатор и IP-адрес рекламодателям (или рекламным сетям), чтобы они могли найти подходящие объявления для показа Вам в наших Играх и в играх третьих лиц. Вы можете контролировать и ограничивать использование нами Вашего рекламного идентификатора в настройках Вашего устройства. Мы не контролируем, какие именно объявления показываются в наших Играх (это контролируется рекламными сетями), но мы вносим определенные категории объявлений в черный список.

        </span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
				Рекламные идентификаторы используются рекламными сетями для различных целей, в том числе чтобы:
        </span>
      </p>
      <ul style={{ margin: '0pt', paddingLeft: '0pt' }}>
        <li
          style={{
            marginTop: '14pt',
            marginLeft: '27.6pt',
            marginBottom: '12pt',
              lineHeight: 'normal',
            paddingLeft: '8.4pt',
            fontFamily: 'serif',
            fontSize: '10pt',
          }}
        >
          <span style={{ fontFamily: 'Times New Roman', fontSize: '12pt' }}>
            ограничить количество просмотров одного и того же объявления;
          </span>
        </li>
        <li
          style={{
            marginLeft: '27.6pt',
            marginBottom: '12pt',
              lineHeight: 'normal',
            paddingLeft: '8.4pt',
            fontFamily: 'serif',
            fontSize: '10pt',
          }}
        >
          <span style={{ fontFamily: 'Times New Roman', fontSize: '12pt' }}>
            убедиться, что они имеют дело с людьми с реальными устройствами, а не с "автоматизированными" ботами;
          </span>
        </li>
        <li
          style={{
            marginLeft: '27.6pt',
            marginBottom: '12pt',
              lineHeight: 'normal',
            paddingLeft: '8.4pt',
            fontFamily: 'serif',
            fontSize: '10pt',
          }}
        >
          <span style={{ fontFamily: 'Times New Roman', fontSize: '12pt' }}>
            предоставлять Вам рекламу, которая может быть релевантной для Вас, на основе Вашего рекламного идентификатора и взаимодействия с другими брендами и объявлениями, также регистрируемого с помощью Вашего рекламного идентификатора и с использованием Вашего общего географического региона. Другие бренды покупают размещение рекламы через рекламную сеть или биржу объявлений, чтобы рекламировать свои продукты в наших Играх. Рекламная сеть или биржа объявлений выступает в качестве посредника между другими игровыми компаниями и Нами. Для того чтобы рекламная сеть могла выставить счет компании, покупающей рекламу, отслеживаются клики по рекламе и возможные установки приложений других разработчиков. Количество просмотров, кликов и установок по рекламным объявлениям измеряется с помощью Advertiser ID;
          </span>
        </li>
        <li
          style={{
            marginLeft: '27.6pt',
            marginBottom: '12pt',
              lineHeight: 'normal',
            paddingLeft: '8.4pt',
            fontFamily: 'serif',
            fontSize: '10pt',
          }}
        >
          <span style={{ fontFamily: 'Times New Roman', fontSize: '12pt' }}>
            отслеживать, какими играми Вы пользовались, чтобы предлагать Вам аналогичные игры. IP-адрес обычно используется рекламодателями для определения общей географической зоны, из которой Вы пришли (например, страны, штата, а иногда и города).
          </span>
        </li>
      </ul>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>4.3. Просмотр Нашей рекламы на сторонних сервисах</span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
				Мы также рекламируем Игры в других приложениях, обращаясь к рекламным сетям с просьбой показать их аудитории, которая будет в них заинтересована (определяется с помощью рекламных идентификаторов).

        </span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
				Рекламные идентификаторы используются рекламными сетями для различных целей, включая:
        </span>
      </p>
      <ul style={{ margin: '0pt', paddingLeft: '0pt' }}>
        <li
          style={{
            marginTop: '14pt',
            marginLeft: '27.6pt',
            marginBottom: '12pt',
              lineHeight: 'normal',
            paddingLeft: '8.4pt',
            fontFamily: 'serif',
            fontSize: '10pt',
          }}
        >
          <span style={{ fontFamily: 'Times New Roman', fontSize: '12pt' }}>
            измерение эффективности рекламы (анализ совокупности просмотров, кликов и установок, которые они генерируют с помощью рекламы в играх других издателей);
          </span>
        </li>
        <li
          style={{
            marginLeft: '27.6pt',
            marginBottom: '12pt',
              lineHeight: 'normal',
            paddingLeft: '8.4pt',
            fontFamily: 'serif',
            fontSize: '10pt',
          }}
        >
          <span style={{ fontFamily: 'Times New Roman', fontSize: '12pt' }}>
            информирование игроков, которые давно не играли, о новом контенте в Игре. Мы передаем список этих пользователей в виде рекламных идентификаторов рекламной сети. Рекламная сеть показывает этим пользователям рекламу о новом контенте;
          </span>
        </li>
        <li
          style={{
            marginLeft: '27.6pt',
            marginBottom: '12pt',
              lineHeight: 'normal',
            paddingLeft: '8.4pt',
            fontFamily: 'serif',
            fontSize: '10pt',
          }}
        >
          <span style={{ fontFamily: 'Times New Roman', fontSize: '12pt' }}>
            не показывать рекламу в игре, в которую игрок уже играет. Мы можем отправить рекламной сети список активных игроков в виде рекламных идентификаторов. Рекламная сеть исключает показ рекламы этим игрокам;
          </span>
        </li>
        <li
          style={{
            marginLeft: '27.6pt',
            marginBottom: '12pt',
              lineHeight: 'normal',
            paddingLeft: '8.4pt',
            fontFamily: 'serif',
            fontSize: '10pt',
          }}
        >
          <span style={{ fontFamily: 'Times New Roman', fontSize: '12pt' }}>
            маркетинговые акции для группы потенциальных игроков.
          </span>
        </li>
      </ul>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>4.4. КТО МОЖЕТ ПОКАЗЫВАТЬ ВАМ ПЕРСОНАЛИЗИРОВАННЫЕ ОБЪЯВЛЕНИЯ?</span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
          Ознакомиться со списком поставщиков рекламы, которым разрешено показывать персонализированную рекламу, и изучить их методы обработки данных, включая технологии, используемые ими для целей персонализированной рекламы, можно

        </span>
        <strong>
          <u>
            <Link className={styles.link} to="/providers" style={{ fontFamily: 'Times New Roman' }}>здесь</Link>.
          </u>
        </strong>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>4.5. КАК ОТКЛЮЧИТЬ ПЕРСОНАЛИЗИРОВАННУЮ РЕКЛАМУ?</span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
				Помимо специальных инструментов, доступных пользователям в Игре, Вы можете использовать настройки своего устройства.
        </span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>iOS</span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
          				Откройте приложение "Настройки" iOS и выберите пункт меню "Конфиденциальность", а затем подпункт "Реклама". Если Вы активируете опцию "Ограничить отслеживание рекламы", мы сможем принимать только ограниченные меры, такие как идентификация уникальных пользователей или борьба с мошенничеством. В этом же меню всегда можно удалить IDFA ("Сбросить Ad-ID"), после чего создается новый идентификатор, который не объединяется с ранее собранными данными.

        </span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>Android</span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
				Откройте приложение "Настройки" и выберите пункт меню "Google". В зависимости от устройства этот пункт может не отображаться в главном меню, но для его поиска можно воспользоваться функцией поиска в верхней части меню "Настройки". Оттуда выберите подпункт "Реклама" и активируйте опцию "Отказаться от персонализации рекламы", чтобы предотвратить создание профилей и показ персонализированной рекламы. В этом же меню можно в любой момент удалить рекламный ID ("Сбросить рекламный ID"), после чего будет создан новый ID, который не будет объединен с ранее собранными данными.

        </span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>5. СТОРОННИЕ СОЦИАЛЬНЫЕ СЕТИ</span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>5.1. Подключение к сторонним социальным сетям</span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
          				Некоторые из наших Игр используют услуги третьих лиц, например, Facebook ("Сторонняя социальная сеть/социальные сети"). В таких Играх Вы можете войти в свою учетную запись в сторонней социальной сети, чтобы подключиться к нашему приложению, используя функцию "Войти" в нашем приложении. Вы также можете делиться контентом, созданным в Приложении, в сторонних социальных сетях. Эти услуги не активируются автоматически, а требуют явного разрешения с Вашей стороны. Обратите внимание, что сторонние социальные сети регулируются собственными политиками конфиденциальности, условиями и соглашениями с конечными пользователями, и мы не несем ответственности и не имеем контроля над практикой обмена информацией или политикой третьих лиц, которые управляют этими сайтами. По дополнительным вопросам обращайтесь к нам по адресу &nbsp;

          <a className={styles.link} href="mailto:support@bofp.co">
            support@bofp.co
          </a>
          .
        </span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>5.2. Вход в систему Facebook</span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
				В наших играх мы можем предложить вам воспользоваться услугой "Facebook Login", предоставляемой компанией Facebook Ireland Limited, 4 Grand Canal Square, Dublin 2, Ireland. Это позволит Вам сохранить весь игровой процесс, используя существующую учетную запись Facebook. После того как Вы войдете в систему, используя свои данные для входа в Facebook, Facebook сообщит Вам, какие данные будут переданы для аутентификации. Правовым основанием для обработки Ваших данных является исполнение нашего договора, ст. 6 (1)(b) GDPR. Мы заключили с компанией Facebook соглашение о совместной ответственности в отношении обработки Ваших данных в соответствии со ст. 26 GDPR, с условиями которого Вы можете ознакомиться

        </span>
        <a
          href="https://www.facebook.com/legal/controller_addendum"
          target="_blank"
          style={{ textDecoration: 'none' }}
          rel="noreferrer"
        >
          <span style={{ fontFamily: 'Times New Roman', color: '#000000' }}>здесь</span>
        </a>
        <span style={{ fontFamily: 'Times New Roman' }}>: </span>
        <span style={{ fontFamily: 'Times New Roman' }}>&nbsp;</span>
        <span style={{ fontFamily: 'Times New Roman' }}>https://www.facebook.com/legal/controller_addendum</span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
          				Более подробную информацию о том, как Facebook обрабатывает персональные данные, в том числе о том, как реализовать свои права как субъекта данных в отношении Facebook Ireland, можно найти в политике Facebook в отношении данных по адресу

        </span>
        <a
          href="https://www.facebook.com/about/privacy"
          target="_blank"
          style={{ textDecoration: 'none' }}
          rel="noreferrer"
        >
          <u>
            <span style={{ fontFamily: 'Times New Roman', color: '#ff313f' }}>
              https://www.facebook.com/about/privacy
            </span>
          </u>
        </a>
        <span style={{ fontFamily: 'Times New Roman' }}>. </span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
				По такому же принципу мы можем предложить Вам использовать для входа в систему свои данные из другой социальной сети наподобие Facebook.

        </span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
          5.3. Информация, которую мы можем получить при подключении к сторонним социальным сетям
        </span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
 				Информация, к которой Вы разрешаете нам доступ, зависит от приложения и от настроек конфиденциальности, установленных Вами в этих сторонних социальных сетях. Вы можете управлять этими настройками и получить более подробную информацию о них в соответствующей сторонней социальной сети. Когда Вы используете функцию "Войти", мы можем получать доступ и хранить некоторые или все следующие сведения, если это разрешено Вами, сторонними социальными сетями и Вашими предпочтениями: (i) Вашу основную информацию из Вашего открытого профиля. По умолчанию сюда входит определенная информация о Вас, такая как id, имя, фотография, пол и Ваше местоположение. Если Вы сделали более подробную информацию о себе общедоступной, то будет доступно больше информации; (ii) идентификатор входа в систему и/или строка идентификатора игрока, Ваш адрес электронной почты, связанный с Вашей страницей; (iii) список Ваших друзей; (iv) любая другая информация, которая подробно описана и показана Вам в уведомлении, появляющемся во время процесса "Войти через". Мы можем показывать Ваше имя и Ваши игровые данные (например, ходы, прогресс в игре и количество заработанной внутриигровой валюты) в отношении соответствующего приложения Вашим друзьям, которые также использовали функцию "Войти через" или "Подключиться к" в связи с таким приложением, или Вашим контактам в соответствующей учетной записи сторонней социальной сети.

        </span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
   				Приложение может также попросить Вас разрешить нам размещать от Вашего имени сообщения в таких сторонних социальных сетях (например, обновления статуса). Пожалуйста, имейте в виду, что мы будем делать это только в том случае, если Вы дадите на это специальное разрешение, и будем хранить ID и Ваше полное имя для целей идентификации пользователя. Остальная информация будет храниться только в приложении на Вашем устройстве, чтобы приложение могло напрямую взаимодействовать со сторонними социальными сетями.

        </span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>5.4.</span>
        <span style={{ fontFamily: 'Times New Roman' }}>&nbsp;</span>
        <span style={{ fontFamily: 'Times New Roman' }}>
          Как Вы делитесь своей информацией в сторонних социальных сетях
        </span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
				Если Вы используете сторонние социальные сети для участия в игровых мероприятиях, таких как таблицы лидеров и многопользовательские игры, Вы делитесь своей информацией с другими игроками и сторонними социальными сетями (например, оценками, рейтингами и достижениями).

        </span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>6. НЕПРИКОСНОВЕННОСТЬ ЧАСТНОЙ ЖИЗНИ ДЕТЕЙ</span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
        				Наш Сервис не предназначен для лиц, не достигших 16-летнего возраста ("Дети"). Когда мы собираем личную информацию, мы не знаем возраст наших игроков. Мы сознательно не собираем персональную информацию от детей младше 16 лет. Если Вы являетесь родителем или опекуном и Вам известно, что Ваши дети предоставили нам личную информацию, пожалуйста, свяжитесь с нами. Если нам станет известно, что мы собрали Личную информацию от ребенка младше 16 лет без подтверждения согласия родителей, мы примем меры для удаления такой информации с наших серверов.

        </span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
        				В соответствии с Условиями предоставления услуг пользователи наших Игр должны быть не моложе 16 лет. Несмотря на то, что графическое содержание Игр может подходить для более молодой аудитории, существует множество причин, по которым ответственные разработчики применяют минимальный возраст 16 лет. Среди таких причин - покупки в приложениях и конфиденциальность.

        </span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
				Обратите внимание: при загрузке наших Игр, например, из Google Play или Apple App Store, в описании приложений можно найти опубликованные возрастные рекомендации. Однако эти возрастные рекомендации касаются только соответствия содержания (аналогично рейтингам фильмов G, PG или PG-13 в США, но касаются игрового процесса, анимации и т.д.) по мнению соответствующего рейтингового органа, ответственного за такие рейтинги. Поскольку эти рейтинги составляются третьей стороной без нашего участия, они не всегда соответствуют нашим Условиям предоставления услуг.

        </span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
				Более подробную информацию о том, как определяются эти категории, можно получить на сайтах поддержки Apple и Google.
        </span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>7. ВАШИ ПРАВА</span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
				Вы имеете определенные права в связи с Вашей личной информацией и тем, как мы ее обрабатываем. На некоторые из этих прав могут распространяться определенные исключения или ограничения. Вы можете воспользоваться этими правами в любое время, следуя приведенным ниже инструкциям или направив нам соответствующие запросы по адресу &nbsp;

          <a className={styles.link} href="mailto:support@bofp.co">
            support@bofp.co
          </a>
        </span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>Ваши права включают:</span>
      </p>
      <ul style={{ margin: '0pt', paddingLeft: '0pt' }}>
        <li
          style={{
            marginTop: '14pt',
            marginLeft: '27.6pt',
            marginBottom: '12pt',
              lineHeight: 'normal',
            paddingLeft: '8.4pt',
            fontFamily: 'serif',
            fontSize: '10pt',
          }}
        >
          <span style={{ fontFamily: 'Times New Roman', fontSize: '12pt' }}>
            Право на отзыв согласия в соответствии со ст. 7 п. 3 GDPR (например, Вы можете отозвать свое согласие на показ Вам персонализированных рекламных объявлений, как описано в настоящей Политике конфиденциальности).
          </span>
          <span style={{ fontFamily: 'Times New Roman', fontSize: '12pt' }}>&nbsp;</span>
        </li>
        <li
          style={{
            marginLeft: '27.6pt',
            marginBottom: '12pt',
              lineHeight: 'normal',
            paddingLeft: '8.4pt',
            fontFamily: 'serif',
            fontSize: '10pt',
          }}
        >
          <span style={{ fontFamily: 'Times New Roman', fontSize: '12pt' }}>
            Право на доступ к своим данным в соответствии со ст. 15 GDPR (например, Вы можете проверить, какие данные мы храним о Вас, для этого свяжитесь с нами по электронной почте &nbsp;
            <a className={styles.link} href="mailto:support@bofp.co">
            support@bofp.co
            </a>
            )
          </span>
        </li>
        <li
          style={{
            marginLeft: '27.6pt',
            marginBottom: '12pt',
              lineHeight: 'normal',
            paddingLeft: '8.4pt',
            fontFamily: 'serif',
            fontSize: '10pt',
          }}
        >
          <span style={{ fontFamily: 'Times New Roman', fontSize: '12pt' }}>
            Право на исправление своих данных в соответствии со ст. 16 GDPR
          </span>
        </li>
        <li
          style={{
            marginLeft: '27.6pt',
            marginBottom: '12pt',
              lineHeight: 'normal',
            paddingLeft: '8.4pt',
            fontFamily: 'serif',
            fontSize: '10pt',
          }}
        >
          <span style={{ fontFamily: 'Times New Roman', fontSize: '12pt' }}>
            Право на удаление своих данных в соответствии со ст. 17 GDPR (например, Вы можете связаться с нами по электронной почте   &nbsp;       </span>
          <span style={{ fontFamily: 'Calibri', fontSize: '11pt' }}> </span>
          <span style={{ fontFamily: 'Times New Roman', fontSize: '12pt' }}>
            via e-mail{' '}
            <a className={styles.link} href="mailto:support@bofp.co">
            support@bofp.co
          </a>{' '}
            , если Вы хотите, чтобы мы удалили определенные данные, которые мы сохранили о Вас).
          </span>
        </li>
        <li
          style={{
            marginLeft: '27.6pt',
            marginBottom: '12pt',
              lineHeight: 'normal',
            paddingLeft: '8.4pt',
            fontFamily: 'serif',
            fontSize: '10pt',
          }}
        >
          <span style={{ fontFamily: 'Times New Roman', fontSize: '12pt' }}>
            Право на ограничение обработки Вашей персональной информации в соответствии со ст. 18 GDPR (например, Вы можете связаться с нами по электронной почте&nbsp;
          </span>
          <span style={{ fontFamily: 'Calibri', fontSize: '11pt' }}> </span>
          <span style={{ fontFamily: 'Times New Roman', fontSize: '12pt' }}>
            <a className={styles.link} href="mailto:support@bofp.co">
            support@bofp.co
          </a>{' '}
            если хотите ограничить обработку). При определенных обстоятельствах Вы имеете право ограничить обработку Ваших Данных. В этом случае мы не будем обрабатывать Ваши данные ни для каких других целей, кроме как для их хранения.
          </span>
        </li>
        <li
          style={{
            marginLeft: '27.6pt',
            marginBottom: '12pt',
              lineHeight: 'normal',
            paddingLeft: '8.4pt',
            fontFamily: 'serif',
            fontSize: '10pt',
          }}
        >
          <span style={{ fontFamily: 'Times New Roman', fontSize: '12pt' }}>
            Право забрать свои данные с собой в соответствии со ст. 20 GDPR (например, Вы можете связаться с нами по электронной почте&nbsp;
          </span>
          <span style={{ fontFamily: 'Calibri', fontSize: '11pt' }}> </span>
          <span style={{ fontFamily: 'Times New Roman', fontSize: '12pt' }}>
            <a className={styles.link} href="mailto:support@bofp.co">
            support@bofp.co
          </a>{' '}
            чтобы получить свои данные, если Вы хотите загрузить их в другой сервис).          </span>
        </li>
        <li
          style={{
            marginLeft: '27.6pt',
            marginBottom: '12pt',
              lineHeight: 'normal',
            paddingLeft: '8.4pt',
            fontFamily: 'serif',
            fontSize: '10pt',
          }}
        >
          <span style={{ fontFamily: 'Times New Roman', fontSize: '12pt' }}>
            Право возражать против того, как обрабатываются Ваши данные в соответствии со ст. 21 GDPR (например, Вы можете связаться с нами, если Вы не согласны с какими-либо процедурами пользовательской аналитики, описанными в настоящей Политике конфиденциальности). Вы имеете право возражать против обработки Ваших данных, если обработка осуществляется на правовой основе, отличной от согласия. Если Персональные данные обрабатываются в общественных интересах, для осуществления официальных полномочий, которыми обладает BATTLE OF PREDICTIONS, или в целях соблюдения законных интересов, преследуемых нами, Вы можете возразить против такой обработки, предоставив основание, связанное с Вашей конкретной ситуацией, для обоснования возражения. Однако Вы должны знать, что если ваши Персональные данные будут обрабатываться в целях прямого маркетинга, Вы можете в любое время возразить против такой обработки без предоставления каких-либо обоснований. Чтобы узнать, обрабатываем ли мы Персональные данные в целях прямого маркетинга, Вы можете обратиться к соответствующим разделам данного документа или связаться с нами по адресу&nbsp;
            <a className={styles.link} href="mailto:support@bofp.co">
            support@bofp.co
          </a>
            .
          </span>
          <span style={{ fontFamily: 'Times New Roman', fontSize: '12pt' }}>&nbsp;</span>
        </li>
        <li
          style={{
            marginLeft: '27.6pt',
            marginBottom: '12pt',
              lineHeight: 'normal',
            paddingLeft: '8.4pt',
            fontFamily: 'serif',
            fontSize: '10pt',
          }}
        >
          <span style={{ fontFamily: 'Times New Roman', fontSize: '12pt' }}>
            Право направлять жалобы в надзорный орган в соответствии со ст. 77 п. 1 f GDPR (например, Вы можете напрямую обратиться в надзорный орган по защите данных).
          </span>
        </li>
      </ul>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>&nbsp;</span>
        <span style={{ fontFamily: 'Times New Roman' }}>8. ОБЩИЕ СВЕДЕНИЯ</span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
				Конфиденциальность и безопасность Вашей информации очень важны для нас, и мы всегда уделяем особое внимание тому, чтобы обработка Вашей информации осуществлялась на законных основаниях в соответствии с одной из правовых основ, предусмотренных законами Европейской экономической зоны (ЕЭЗ) о защите данных, которые применяются к нашим пользователям. Мы храним вашу информацию столько, сколько необходимо для предоставления Вам наших Услуг. Мы можем хранить информацию дольше, но только таким образом, чтобы ее нельзя было отследить. Мы работаем по всему миру и передаем Вашу информацию нашим партнерам (см. список наших действующих партнеров

        </span>
        <strong>
          <u>
            <Link className={styles.link} to="/providers" style={{ fontFamily: 'Times New Roman' }}>(здесь)</Link>
          </u>
        </strong>
        <span style={{ fontFamily: 'Times New Roman' }}>
          в целях, описанных выше в разделе "Как мы передаем Вашу информацию", что может включать передачу Вашей личной информации за пределы ЕЭЗ. Пожалуйста, регулярно проверяйте изменения в нашей Политике конфиденциальности.
        </span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>9. ПРАВОВЫЕ ОСНОВАНИЯ</span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
				В каждом случае, когда мы обрабатываем Вашу информацию, мы делаем это на законных основаниях в соответствии с одним из правовых оснований, установленных законодательством ЕЭЗ о защите данных.

        </span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>Мы опираемся на следующие правовые основания:</span>
      </p>
      <ul style={{ margin: '0pt', paddingLeft: '0pt' }}>
        <li
          style={{
            marginTop: '14pt',
            marginLeft: '27.6pt',
            marginBottom: '12pt',
              lineHeight: 'normal',
            paddingLeft: '8.4pt',
            fontFamily: 'serif',
            fontSize: '10pt',
          }}
        >
          <span style={{ fontFamily: 'Times New Roman', fontSize: '12pt' }}>
            Договорная необходимость. Сюда относится информация, обрабатываемая нами для предоставления Вам Услуг, которые Вы запросили - и которые мы согласились Вам предоставить, - то есть для предоставления и улучшения наших Услуг, обеспечения поддержки клиентов, предоставления специальных функций в наших Играх (таких как функция чата в приложении, функция многопользовательской игры, таблицы лидеров и другие функции социальных сетей третьих сторон), предоставления содержимого сделанной Вами покупки в приложении.
          </span>
        </li>
        <li
          style={{
            marginLeft: '27.6pt',
            marginBottom: '12pt',
              lineHeight: 'normal',
            paddingLeft: '8.4pt',
            fontFamily: 'serif',
            fontSize: '10pt',
          }}
        >
          <span style={{ fontFamily: 'Times New Roman', fontSize: '12pt' }}>
            Законные интересы. К ним относится информация, обрабатываемая нами в целях, которые можно обоснованно ожидать в контексте использования Вами наших Услуг для реализации наших законных интересов, чтобы обеспечить Вам наилучшие впечатления от игры в наших приложениях, обеспечить безопасность Вашей информации и предоставить Вам наши Игры бесплатно или по низкой цене. Мы уделяем особое внимание Вашим правам на защиту данных, следя за тем, чтобы Ваши права на защиту данных не перекрывались нашими законными интересами. Мы исходим из своих законных интересов при обработке данных для целей аналитики, отслеживания и предотвращения мошенничества, push-уведомлений, перекрестного продвижения, контекстной рекламы.
          </span>
        </li>
        <li
          style={{
            marginLeft: '27.6pt',
            marginBottom: '12pt',
              lineHeight: 'normal',
            paddingLeft: '8.4pt',
            fontFamily: 'serif',
            fontSize: '10pt',
          }}
        >
          <span style={{ fontFamily: 'Times New Roman', fontSize: '12pt' }}>
          Согласие. Если мы запрашиваем Ваше согласие на использование Ваших данных в определенных целях, мы дадим это понять в момент сбора, а также разъясним, как Вы можете отозвать свое согласие. Мы будем запрашивать Ваше согласие перед передачей информации нашим рекламным партнерам для целей персонализированной рекламы и перед проведением опросов. Примечание: В соответствии с некоторыми законодательными актами нам может быть разрешено обрабатывать Персональные данные до тех пор, пока Вы не заявите о своем несогласии на такую обработку ("отказ"), без необходимости полагаться на согласие или любое другое из перечисленных ниже правовых оснований. Это, однако, не относится к случаям, когда обработка Персональных данных регулируется европейским законодательством о защите данных.
          </span>
        </li>
        <li
          style={{
            marginLeft: '27.6pt',
            marginBottom: '12pt',
              lineHeight: 'normal',
            paddingLeft: '8.4pt',
            fontFamily: 'serif',
            fontSize: '10pt',
          }}
        >
          <span style={{ fontFamily: 'Times New Roman', fontSize: '12pt' }}>
            Юридические обязательства. Сюда относится информация, которая обрабатывается нами для выполнения юридических обязательств, например, для ведения учета в целях налогообложения.

          </span>
        </li>
      </ul>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
          В любом случае мы с удовольствием поможем уточнить, на каком именно законном основании осуществляется обработка, в частности, является ли предоставление Персональных данных требованием закона или договора, или требованием, необходимым для заключения договора.
        </span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>10. БЕЗОПАСНОСТЬ</span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
        				Мы применяем соответствующие технические и организационные меры для защиты конфиденциальности, безопасности и целостности собранной информации, а также для предотвращения несанкционированного доступа и использования информации, противоречащей настоящей Политике конфиденциальности. Несмотря на то, что мы прилагаем коммерчески обоснованные усилия для обеспечения сохранности Вашей информации при ее хранении, пожалуйста, помните, что никакие меры безопасности не являются абсолютно совершенными или непробиваемыми.

        </span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>11. МЕЖДУНАРОДНАЯ ПЕРЕДАЧА ДАННЫХ</span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
          				Обработка информации осуществляется в операционных офисах BATTLE OF PREDICTIONS и в любых других местах, где находятся стороны, участвующие в обработке.

        </span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
				Ваши персональные данные могут передаваться и обрабатываться в странах, отличных от страны, резидентом которой Вы являетесь. В этих странах могут действовать законы о защите данных, отличные от законов Вашей страны.

        </span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
   				Это означает, что, собирая Вашу личную информацию, мы можем обрабатывать ее в других странах. Однако мы обеспечиваем соответствующие гарантии, чтобы Ваша личная информация оставалась защищенной в соответствии с настоящей Политикой конфиденциальности. К ним относится применение Стандартных договорных положений Европейской комиссии о передаче личной информации между нами и сторонними поставщиками услуг и партнерами, которые требуют от нас защиты личной информации, обрабатываемой ими на территории ЕЭЗ, в соответствии с законодательством Европейского союза о защите данных.

        </span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>12. ХРАНЕНИЕ ДАННЫХ</span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
          				Мы храним Вашу информацию столько, сколько необходимо для предоставления Вам наших Услуг. Мы можем хранить информацию дольше, но только таким образом, чтобы ее нельзя было отследить. Мы удаляем информацию, как только она становится не нужна нам для целей, описанных в настоящей Политике конфиденциальности, но в любом случае не позднее чем через пять (5) лет после прекращения Вашего взаимодействия со всеми нашими Играми.

        </span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
				Если это требуется по закону, мы сохраняем Вашу информацию до тех пор, пока это необходимо по закону. Если Вы попросите нас удалить Ваши данные, мы удалим их, как описано выше в разделе "Ваши права".

        </span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
      				По истечении срока хранения Персональные данные подлежат уничтожению. Таким образом, право на доступ, право на удаление, право на исправление и право на переносимость данных не могут быть реализованы после истечения срока хранения.

        </span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>13. ИНФОРМАЦИЯ ДЛЯ КАЛИФОРНИЙСКИХ ПОТРЕБИТЕЛЕЙ</span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
          				Эта часть документа объединяет и дополняет информацию, содержащуюся в остальной части Политики конфиденциальности, и предоставляется нами и нашими дочерними и аффилированными компаниями (для целей данного раздела совместно именуемыми "мы", "нас", "наш").

        </span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
     				Положения, содержащиеся в настоящем разделе, распространяются на всех пользователей, являющихся потребителями, проживающими в штате Калифорния, Соединенные Штаты Америки, в соответствии с "Калифорнийским законом о конфиденциальности потребителей 2018 года" (далее пользователи именуются просто "Вы", "Ваш"), и для таких потребителей эти положения имеют преимущественную силу перед любыми другими, возможно, расходящимися или противоречащими друг другу положениями, содержащимися в Политике конфиденциальности.

        </span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
   				В данной части документа термин "персональная информация" используется в том значении, в каком он определен в Законе Калифорнии о защите частной жизни потребителей (CCPA).

        </span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <em>
          <span style={{ fontFamily: 'Times New Roman' }}>
            13.1. Категории собираемой, раскрываемой или продаваемой персональной информации
          </span>
        </em>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
  				В этом разделе мы кратко перечисляем категории личной информации, которую мы собираем и/или раскрываем, а также цели ее использования. Более подробно об этих действиях Вы можете прочитать в разделе 2 "Как мы используем Вашу информацию" настоящего документа.

        </span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <em>
          <span style={{ fontFamily: 'Times New Roman' }}>
            				Собираемая нами информация: категории собираемой нами личной информации

          </span>
        </em>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
				В соответствии с CCPA мы собираем следующие категории персональной информации о Вас: идентификаторы, коммерческая информация, информация доступная в Интернете и геолокационные данные.

        </span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
				Мы не будем собирать дополнительные категории личной информации без Вашего уведомления.
        </span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <em>
          <span style={{ fontFamily: 'Times New Roman' }}>
            13.2. Как мы собираем информацию: каковы источники собираемой нами личной информации?
          </span>
        </em>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
 				Мы собираем перечисленные выше категории личной информации, прямо или косвенно, от Вас, когда Вы пользуетесь нашими Услугами и Играми.

        </span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
      				Например, Вы напрямую предоставляете свои персональные данные при отправке запросов через любые формы в сервисах или Играх. Вы также предоставляете личную информацию косвенно при навигации по сервисам и Играм, поскольку личная информация о Вас автоматически замечается и собирается. Наконец, мы можем собирать Ваши персональные данные у третьих лиц, которые сотрудничают с нами в связи с оказанием нами Услуг или функционированием Игр.

        </span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <em>
          <span style={{ fontFamily: 'Times New Roman' }}>
            13.3. Как мы используем собранную нами информацию: совместное использование и раскрытие Вашей личной информации третьим лицам с деловой целью
          </span>
        </em>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
				Мы можем раскрывать собранную о Вас личную информацию третьим лицам в коммерческих целях. В этом случае мы заключаем письменное соглашение с такой третьей стороной, которое обязывает получателя сохранять конфиденциальность личной информации и не использовать ее для каких-либо целей, кроме тех, которые необходимы для выполнения соглашения.

        </span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
				Мы также можем раскрывать Вашу личную информацию третьим лицам, если Вы прямо попросите или разрешите нам сделать это, чтобы предоставить Вам наши Услуги.

        </span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
				Для получения более подробной информации о целях обработки данных обратитесь к соответствующему разделу данного документа.
        </span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <em>
          <span style={{ fontFamily: 'Times New Roman' }}>13.4. Продажа Вашей персональной информации</span>
        </em>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
				Для наших целей слово "продажа" означает любую "продажу, сдачу в аренду, выдачу, раскрытие, распространение, предоставление, передачу или иное сообщение в устной, письменной или электронной форме персональной информации потребителя предприятием другому предприятию или третьей стороне за денежное или иное ценное вознаграждение".

        </span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
				Это означает, что, например, продажа может происходить всякий раз, когда приложение запускает рекламу, или проводит статистический анализ трафика или просмотров, или просто потому, что оно использует такие инструменты, как плагины для социальных сетей и т.п.

        </span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <em>
          <span style={{ fontFamily: 'Times New Roman' }}>
				Ваше право отказаться от продажи персональной информации
          </span>
        </em>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
          				Вы имеете право отказаться от продажи Вашей личной информации. Это означает, что если Вы попросите нас прекратить продажу Ваших данных, мы выполним Ваше требование.

        </span>
        <br />
        <span style={{ fontFamily: 'Times New Roman' }}>
 Такой запрос можно сделать свободно, в любое время, просто следуя приведенным ниже инструкциям.
        </span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <em>
          <span style={{ fontFamily: 'Times New Roman' }}>
           Инструкции по отказу от продажи персональных данных
          </span>
        </em>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
				Если Вы хотите узнать больше или воспользоваться своим правом на отказ от продажи данных, осуществляемых с помощью данного приложения как в режиме онлайн, так и офлайн, Вы можете связаться с нами для получения дополнительной информации, используя контактную информацию, указанную в данном документе.

        </span>
        <span style={{ fontFamily: 'Times New Roman' }}>&nbsp;</span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <em>
          <span style={{ fontFamily: 'Times New Roman' }}>
            13.5. Для каких целей мы используем Вашу личную информацию?
          </span>
        </em>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
				Мы можем использовать Вашу личную информацию для обеспечения оперативного функционирования Услуг или Игр и их функций ("деловые цели"). В таких случаях Ваша личная информация будет обрабатываться таким образом, который необходим и соразмерен деловой цели, для которой она была собрана, и строго в пределах совместимых рабочих целей.

        </span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
   				Мы также можем использовать Вашу личную информацию по другим причинам, например, в коммерческих целях, а также для соблюдения законодательства и защиты наших прав в компетентных органах, если нашим правам и интересам угрожает опасность или нам нанесен реальный ущерб.

        </span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
				Мы не будем использовать Вашу личную информацию в иных, не связанных или несовместимых целях без уведомления Вас.

        </span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <em>
          <span style={{ fontFamily: 'Times New Roman' }}>
            13.6. Ваши права на конфиденциальность в Калифорнии и порядок их реализации
          </span>
        </em>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <em>
          <span style={{ fontFamily: 'Times New Roman' }}>Право на информацию и переносимость</span>
        </em>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
          				Один раз в год Вы можете бесплатно подать запрос на раскрытие персональной информации, которую мы собираем о Вас. Проще всего отправить запрос через службу поддержки в самой Игре (если это возможно). Вы также можете отправить запрос по электронной почте&nbsp;

        </span>
        <u>
          <span style={{ fontFamily: 'Times New Roman', color: '#ff313f' }}>
          <a className={styles.link} href="mailto:support@bofp.co">
            support@bofp.co
          </a>
          </span>
        </u>
        <span style={{ fontFamily: 'Times New Roman' }}>.</span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
				Описанное выше раскрытие будет ограничено личной информацией, собранной или использованной за последние 12 месяцев.

        </span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
    				Если мы направляем ответ в электронном виде, то прилагаемая к нему информация будет "переносимой", т.е. предоставленной в удобном для использования формате, позволяющем беспрепятственно передать ее другому лицу - при условии, что это технически осуществимо.

        </span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <em>
          <span style={{ fontFamily: 'Times New Roman' }}>
           				Право запросить удаление Вашей личной информации

          </span>
        </em>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
				Вы имеете право потребовать от нас удаления любой Вашей личной информации, с учетом исключений, установленных законодательством (например, в случаях, когда информация используется для выявления и устранения ошибок в данном Приложении, для обнаружения инцидентов безопасности и защиты от мошеннических или незаконных действий, для осуществления определенных прав и т.д.).

        </span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
   				Если никакие юридические исключения не действуют, то в результате реализации Вашего права мы удалим Вашу личную информацию и поручим это сделать любому из наших поставщиков услуг. Однако мы можем отклонить Ваш запрос на удаление, если сохранение информации необходимо нам или нашим поставщикам услуг при определенных обстоятельствах, которые будут объяснены Вам во время отказа, если таковой будет иметь место. Если Вы хотите удалить любую информацию о себе, Вы можете воспользоваться чатом поддержки в наших Играх (если это возможно) или отправить запрос по электронной почте&nbsp;

          <a className={styles.link} href="mailto:support@bofp.co">
            support@bofp.co
          </a>
          .
        </span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <em>
          <span style={{ fontFamily: 'Times New Roman' }}>Право на отказ от участия</span>
        </em>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
				Вы имеете право отказаться от "продажи" Вашей личной информации, как это определено в CCPA. При определенных обстоятельствах мы можем передавать Вашу информацию нашим партнерам, которые помогают нам размещать рекламу в наших играх с учетом Ваших интересов. Чтобы узнать, какую информацию мы собираем и как мы передаем ее третьим лицам в рекламных целях, пожалуйста, ознакомьтесь с соответствующим разделом настоящей Политики конфиденциальности.

        </span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
				Если Вы предпочитаете, чтобы Ваша личная информация не передавалась третьим лицам таким образом, пожалуйста, воспользуйтесь чатом поддержки в наших Играх (если это возможно) или отправьте свой запрос по электронной почте&nbsp;

          <a className={styles.link} href="mailto:support@bofp.co">
            support@bofp.co
          </a>
          .
        </span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <em>
          <span style={{ fontFamily: 'Times New Roman' }}>Право на свободу от дискриминации</span>
        </em>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
     				Мы не имеем права дискриминировать Вас за осуществление любого из Ваших прав по CCPA. Если это не разрешено CCPA, мы не будем: (i) отказывать Вам в предоставлении наших Услуг; (ii) взимать с Вас отличные от стандартных цены или тарифы за наши Услуги; (iii) предоставлять Вам Услуги иного уровня или качества; (iv) предлагать Вам получить Услуги по иной цене или тарифу, либо Услуги иного уровня или качества.

        </span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>Уполномоченные агенты</span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
				Вы можете воспользоваться своими правами по CCPA, назначив уполномоченного агента. Если Вы хотите назначить уполномоченного агента для подачи запроса от Вашего имени, пожалуйста, убедитесь, что он может (i) подтвердить, что Вы предоставили письменное разрешение на подачу запроса от Вашего имени, и (ii) предоставить документы, удостоверяющие его личность. Мы оставляем за собой право потребовать дополнительную обоснованную информацию для проверки запроса. Если агент не удовлетворяет этим требованиям, мы можем отклонить запрос.

        </span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <em>
          <span style={{ fontFamily: 'Times New Roman' }}>Как реализовать свои права</span>
        </em>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
				Чтобы воспользоваться описанными выше правами, необходимо направить нам свой запрос, связавшись с нами по реквизитам, указанным в данном документе.

        </span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
				Для того чтобы мы могли ответить на Ваш запрос, необходимо, чтобы мы знали, кто Вы. Поэтому Вы можете воспользоваться вышеуказанными правами только путем подачи поддающегося проверке запроса, который должен:

        </span>
      </p>
      <ul style={{ margin: '0pt', paddingLeft: '0pt' }}>
        <li
          style={{
            marginTop: '14pt',
            marginLeft: '27.6pt',
            marginBottom: '12pt',
              lineHeight: 'normal',
            paddingLeft: '8.4pt',
            fontFamily: 'serif',
            fontSize: '10pt',
          }}
        >
          <span style={{ fontFamily: 'Times New Roman', fontSize: '12pt' }}>
         предоставить достаточную информацию, позволяющую нам обоснованно проверить, что Вы являетесь лицом, о котором мы собираем персональные данные, или уполномоченным представителем;
          </span>
        </li>
        <li
          style={{
            marginLeft: '27.6pt',
            marginBottom: '12pt',
              lineHeight: 'normal',
            paddingLeft: '8.4pt',
            fontFamily: 'serif',
            fontSize: '10pt',
          }}
        >
          <span style={{ fontFamily: 'Times New Roman', fontSize: '12pt' }}>
  описать Ваш запрос достаточно подробно, чтобы мы могли правильно понять, оценить и ответить на него.
          </span>
        </li>
      </ul>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
    				Мы не будем отвечать на любой запрос, если не сможем удостовериться в Вашей личности и, соответственно, подтвердить, что имеющаяся у нас личная информация действительно относится к Вам.

        </span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
				Если Вы являетесь взрослым, Вы можете сделать проверяемый запрос от имени несовершеннолетнего, находящегося под Вашим родительским контролем.
        </span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
				Вы можете подать не более 1 заявки в течение 12 месяцев.
        </span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <em>
          <span style={{ fontFamily: 'Times New Roman' }}>Как и когда мы должны обработать Ваш запрос</span>
        </em>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
     				Мы ответим на Ваш запрос в течение 45 дней с момента его получения. Если нам потребуется больше времени, мы объясним Вам причины и сколько еще времени нам необходимо. В связи с этим просим учесть, что на выполнение Вашего запроса может потребоваться до 90 дней. Раскрытие информации будет охватывать период в 12 месяцев.

             </span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
				Если мы отклоним Ваш запрос, мы объясним Вам причины отказа.
        </span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
         				Мы не взимаем плату за обработку или ответ на Ваш проверяемый запрос, если только такой запрос не является явно необоснованным или чрезмерным. В таких случаях мы можем взимать разумную плату или отказать в удовлетворении запроса. В любом случае мы сообщим о своем выборе и объясним его причины.

        </span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>14. ИЗМЕНЕНИЯ В НАШЕЙ ПОЛИТИКЕ КОНФИДЕНЦИАЛЬНОСТИ</span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
				Мы будем периодически обновлять настоящую Политику конфиденциальности, если это необходимо для защиты наших пользователей, предоставления актуальной информации и реагирования на юридические и технические изменения. Самая последняя версия Политики конфиденциальности будет регулировать использование нами Вашей информации и будет доступна

        </span>
        <a
          href="https://playgendary.com/en/playgendary-limited-privacy-policy"
          target="_blank"
          style={{textDecoration: 'none'}}
          rel="noreferrer"
        >
          <span style={{fontFamily: 'Times New Roman', color: '#000000'}}>на</span>
          <span style={{fontFamily: 'Times New Roman'}}> нашем сайте и в играх.</span>
        </a>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>15. СВЯЗАТЬСЯ С НАМИ</span>
      </p>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
   				Если у Вас есть вопросы или сомнения по поводу настоящей Политики конфиденциальности, свяжитесь с нами одним из следующих способов:

        </span>
      </p>
      <ol style={{ margin: '0pt', paddingLeft: '0pt' }}>
        <li
          style={{
            marginTop: '14pt',
            marginLeft: '54.5pt',
            marginBottom: '12pt',
              lineHeight: 'normal',
            paddingLeft: '4pt',
            fontFamily: 'Times New Roman',
            fontSize: '12pt',
          }}
        >
          по нашей электронной почте:&nbsp;
          <a className={styles.link} href="mailto:support@bofp.co">
            support@bofp.co
          </a>
          ;
        </li>
        <li
          style={{
            marginLeft: '54.5pt',
            marginBottom: '12pt',
              lineHeight: 'normal',
            paddingLeft: '4pt',
            fontFamily: 'Times New Roman',
            fontSize: '12pt',
          }}
        >
          через чат поддержки в приложении;
        </li>
        <li
          style={{
            marginLeft: '54.5pt',
            marginBottom: '12pt',
              lineHeight: 'normal',
            paddingLeft: '4pt',
            fontFamily: 'Times New Roman',
            fontSize: '12pt',
          }}
        >
          если у Вас возникли вопросы или требования в отношении обработки нами Ваших персональных данных, Вы можете обратиться в соответствующий орган по защите данных. Контактные данные органа по защите данных можно найти на сайте
          <a
            href="https://edpb.europa.eu/about-edpb/board/members_en"
            target="_blank"
            style={{ textDecoration: 'none' }}
            rel="noreferrer"
          >
            <u>
              <span style={{ color: '#ff313f' }}>https://edpb.europa.eu/about-edpb/board/members_en</span>
            </u>
          </a>
          . Для получения дополнительной информации о том, в какой орган следует обращаться, напишите нам по адресу&nbsp;
          <a className={styles.link} href="mailto:support@bofp.co">
            support@bofp.co
          </a>
          .
        </li>
      </ol>
      <p
        style={{
          marginBottom: '12pt',
          lineHeight: 'normal',
          fontSize: '12pt',
        }}
      >
        <span style={{ fontFamily: 'Times New Roman' }}>
				В отношении информации, собираемой в рамках настоящей Политики конфиденциальности, контроллером данных является BATTLE OF PREDICTIONS TECHNOLOGY INC, компания, действующая в соответствии с законодательством Соединенных Штатов Америки, зарегистрированная по адресу: 2546 e 17th street, 2nd floor, BROOKLYN, NY 11235.

        </span>
      </p>
    </>
  );
}

export default PrivacyListRU;
